import React, { useState, useEffect } from "react";
import { Calendar } from "primereact/calendar";
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { useSelector, useDispatch } from 'react-redux';
import * as jobConstants from "../../enums/jobs";
import moment from "moment";

import {
    fetchSlaReportData,
    fetchSlaDownloadReportData,
    fetchSlaMetBreachDownloadReportData,
    fetchCustomReportData,
    fetchCustomBusinessTypeDownloadReportData,
    fetchCustomPackMetricsDownloadReportData,
    fetchCustomPackVolumnDownloadReportData,
    fetchCurrentReportData,
    fetchCurrentCommsDownloadReportData,
    fetchCurrentRPCDownloadReportData,
    fetchDetailsReportData,
    fetchDetailsDownloadReportData,
    setReportStartDate,
    setReportEndDate,
    setFilterChannelType,
    setFilterDocType,
    setFilterReportType,
    setPage,
    setSize,
    setBasicFirst,
    setBasicRows,
} from "./reportSlice";

const CommonReportFilter = () => {
    const jobState = useSelector((state) => state.job);
    const {
        userId,
        clientId,
        appLanguage,
    } = jobState;
    const protrackReports = useSelector((state) => state.reports);
    const {
        reportStartDate,
        reportEndDate,
        filterChannelType,
        filterDocType,
        filterReportType,
        tabViewType,
        page,
        size,
        basicFirst,
        basicRows,
        filterDetailsKeyword,
    } = protrackReports;

    // For radio buttons
    // const categories = jobConstants.REPORT_FILTER_CATEGORY;
    const categories = [
        { name: appLanguage["report.commonfilter.label.all"], key: 0 },
        { name: appLanguage["report.commonfilter.label.batch"], key: 1 },
        // { name: appLanguage["report.commonfilter.label.adhoc"], key: 2 },
        { name: appLanguage["report.commonfilter.label.ondemand"], key: 2 },
    ];
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(setFilterReportType(1));
        let filterParams = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: filterChannelType.join(","),
            filterType: filterDocType,
            // fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : moment(new Date(new Date().setFullYear(new Date().getFullYear() - 1))).format("YYYY-MM-DD"),
            fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : moment(new Date(new Date().setDate(new Date().getDate() - 2))).format("YYYY-MM-DD"),
            // toDate: reportEndDate ? moment(reportEndDate).format("YYYY-MM-DD") : moment(new Date()).format("YYYY-MM-DD"),
            toDate: reportEndDate ? moment(reportEndDate).format("YYYY-MM-DD") : moment(new Date(new Date().setDate(new Date().getDate() - 1))).format("YYYY-MM-DD"),
            reportType: 1,
        };
        if (tabViewType === 0) {
            dispatch(fetchSlaReportData(filterParams));
            dispatch(fetchSlaDownloadReportData(filterParams));
            dispatch(fetchSlaMetBreachDownloadReportData(filterParams));
        } else if (tabViewType === 1) {
            dispatch(fetchCustomReportData(filterParams));
            dispatch(fetchCustomBusinessTypeDownloadReportData(filterParams));
            dispatch(fetchCustomPackMetricsDownloadReportData(filterParams));
            dispatch(fetchCustomPackVolumnDownloadReportData(filterParams));
        } else if (tabViewType === 3) {
            filterParams.pageNum = page;
            filterParams.pageSize = size;
            filterParams.keyword = filterDetailsKeyword;
            dispatch(fetchDetailsReportData(filterParams));
            dispatch(fetchDetailsDownloadReportData(filterParams));
            // dispatch(setBasicFirst(first));
            // dispatch(setBasicRows(rows));
            // dispatch(setPage(page + 1));
            // dispatch(setSize(rows));
        } else {
            let currentFilterParams = {
                clientId: clientId,
                userId: userId,
                typeId: tabViewType,
                channelType: filterChannelType.join("|"),
                filterType: filterDocType,
                fromDate: moment(new Date()).format("YYYY-MM-DD"),
                toDate: moment(new Date()).format("YYYY-MM-DD"),
                reportType: 1,
            };
            dispatch(fetchCurrentReportData(currentFilterParams));
            dispatch(fetchCurrentCommsDownloadReportData(currentFilterParams));
            dispatch(fetchCurrentRPCDownloadReportData(currentFilterParams));
        }
        // dispatch(fetchSlaReportData(filterParams));
    }, [])

    const onChangeStartDate = (e) => {
        dispatch(setReportEndDate(''));
        // setToDateEnabled(false);
        dispatch(setReportStartDate(e.value));
    }

    const onChangeEndDate = (e) => {
        // dispatch(setReportStartDate(''));
        // setToDateEnabled(false);
        dispatch(setReportEndDate(e.value));

        let filterParams = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: filterChannelType.join("|"),
            filterType: filterDocType,
            fromDate: reportStartDate ? moment(reportStartDate).format("YYYY-MM-DD") : '',
            toDate: e.value ? moment(e.value).format("YYYY-MM-DD") : '',
            reportType: 1,
        };
        if (tabViewType === 0) {
            // filterParams.reportType = 1;
            dispatch(fetchSlaReportData(filterParams));
            dispatch(fetchSlaDownloadReportData(filterParams));
            dispatch(fetchSlaMetBreachDownloadReportData(filterParams));
        } else if (tabViewType === 1) {
            dispatch(fetchCustomReportData(filterParams));
            dispatch(fetchCustomBusinessTypeDownloadReportData(filterParams));
            dispatch(fetchCustomPackMetricsDownloadReportData(filterParams));
            dispatch(fetchCustomPackVolumnDownloadReportData(filterParams));
        } else if (tabViewType === 3) {
            filterParams.pageNum = page;
            filterParams.pageSize = size;
            filterParams.keyword = filterDetailsKeyword;
            dispatch(fetchDetailsReportData(filterParams));
            dispatch(fetchDetailsDownloadReportData(filterParams));
        } else {
            let currentFilterParams = {
                clientId: clientId,
                userId: userId,
                typeId: tabViewType,
                channelType: filterChannelType.join("|"),
                filterType: filterDocType,
                fromDate: moment(new Date()).format("YYYY-MM-DD"),
                toDate: moment(new Date()).format("YYYY-MM-DD"),
                reportType: 1,
            };
            dispatch(fetchCurrentReportData(currentFilterParams));
            dispatch(fetchCurrentCommsDownloadReportData(currentFilterParams));
            dispatch(fetchCurrentRPCDownloadReportData(currentFilterParams));
        }
        // dispatch(fetchSlaReportData(filterParams));
    }

    const getChannelType = (val) => {
        let updatedChannelTypes;
        const currentChannelTypes = Array.isArray(filterChannelType) ? filterChannelType : [filterChannelType];

        if (currentChannelTypes.includes(val)) {
            // Deselect only if more than one channel is selected
            // if (currentChannelTypes.length > 1) {
            //     updatedChannelTypes = currentChannelTypes.filter(type => type !== val);
            // } else {
            //     updatedChannelTypes = currentChannelTypes; // Keep at least one selected
            // }
            updatedChannelTypes = currentChannelTypes.filter(type => type !== val);
        } else {
            // Add to selection
            updatedChannelTypes = [...currentChannelTypes, val];
        }

        dispatch(setFilterChannelType(updatedChannelTypes));
        let filterParams = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: updatedChannelTypes.join("|"),
            filterType: filterDocType,
            fromDate: moment(reportStartDate).format("YYYY-MM-DD"),
            toDate: moment(reportEndDate).format("YYYY-MM-DD"),
            reportType: 1,
        };
        if (tabViewType === 0) {
            // filterParams.reportType = 1;
            dispatch(fetchSlaReportData(filterParams));
            dispatch(fetchSlaDownloadReportData(filterParams));
            dispatch(fetchSlaMetBreachDownloadReportData(filterParams));
        } else if (tabViewType === 1) {
            dispatch(fetchCustomReportData(filterParams));
            dispatch(fetchCustomBusinessTypeDownloadReportData(filterParams));
            dispatch(fetchCustomPackMetricsDownloadReportData(filterParams));
            dispatch(fetchCustomPackVolumnDownloadReportData(filterParams));
        } else if (tabViewType === 3) {
            filterParams.pageNum = page;
            filterParams.pageSize = size;
            filterParams.keyword = filterDetailsKeyword;
            dispatch(fetchDetailsReportData(filterParams));
            dispatch(fetchDetailsDownloadReportData(filterParams));
        } else {
            let currentFilterParams = {
                clientId: clientId,
                userId: userId,
                typeId: tabViewType,
                channelType: updatedChannelTypes.join("|"),
                filterType: filterDocType,
                fromDate: moment(new Date()).format("YYYY-MM-DD"),
                toDate: moment(new Date()).format("YYYY-MM-DD"),
                reportType: 1,
            };
            dispatch(fetchCurrentReportData(currentFilterParams));
            dispatch(fetchCurrentCommsDownloadReportData(currentFilterParams));
            dispatch(fetchCurrentRPCDownloadReportData(currentFilterParams));
        }
    }

    const changeDocType = (e) => {
        dispatch(setFilterDocType(e.value));
        let filterParams = {
            clientId: clientId,
            userId: userId,
            typeId: tabViewType,
            channelType: filterChannelType.join("|"),
            filterType: e.value,
            fromDate: moment(reportStartDate).format("YYYY-MM-DD"),
            toDate: moment(reportEndDate).format("YYYY-MM-DD"),
            reportType: 1,
        };
        if (tabViewType === 0) {
            // filterParams.reportType = 1;
            dispatch(fetchSlaReportData(filterParams));
            dispatch(fetchSlaDownloadReportData(filterParams));
            dispatch(fetchSlaMetBreachDownloadReportData(filterParams));
        } else if (tabViewType === 1) {
            dispatch(fetchCustomReportData(filterParams));
            dispatch(fetchCustomBusinessTypeDownloadReportData(filterParams));
            dispatch(fetchCustomPackMetricsDownloadReportData(filterParams));
            dispatch(fetchCustomPackVolumnDownloadReportData(filterParams));
        } else if (tabViewType === 3) {
            filterParams.pageNum = page;
            filterParams.pageSize = size;
            filterParams.keyword = filterDetailsKeyword;
            dispatch(fetchDetailsReportData(filterParams));
            dispatch(fetchDetailsDownloadReportData(filterParams));
        } else {
            let currentFilterParams = {
                clientId: clientId,
                userId: userId,
                typeId: tabViewType,
                channelType: filterChannelType.join("|"),
                filterType: e.value,
                fromDate: moment(new Date()).format("YYYY-MM-DD"),
                toDate: moment(new Date()).format("YYYY-MM-DD"),
                reportType: 1,
            };
            dispatch(fetchCurrentReportData(currentFilterParams));
            dispatch(fetchCurrentCommsDownloadReportData(currentFilterParams));
            dispatch(fetchCurrentRPCDownloadReportData(currentFilterParams));
        }
        // dispatch(fetchSlaReportData(filterParams));
    }

    return (
        <div className="box-white">
            <h3>{appLanguage["report.commonfilter.label.filter"]}</h3>
            <ul className="reporting-sla-date-box-wrap bdr-top">
                {tabViewType === 2 ? (
                    <li className="full-date">
                        <label htmlFor="">{moment(new Date()).format("DD MMMM YYYY")}</label>
                    </li>
                ) : (
                    <>
                        <li className="from-date">
                            <Calendar
                                value={reportStartDate}
                                onChange={(e) => onChangeStartDate(e)}
                                dateFormat="dd M yy"
                                maxDate={new Date(new Date())}
                                showIcon
                            />
                        </li>
                        <li className="from-date to-date">
                            <Calendar
                                value={reportEndDate}
                                onChange={(e) => onChangeEndDate(e)}
                                minDate={reportStartDate}
                                maxDate={new Date(new Date().setDate(new Date().getDate() - 1))}
                                dateFormat="dd M yy"
                                showIcon
                            />
                        </li>
                    </>
                )}
            </ul>

            <ul className="reporting-sla-icons-box-wrap bdr-top">
                <li>
                    <a className={(Array.isArray(filterChannelType) ? filterChannelType : [filterChannelType]).includes(0) ? 'active' : ''} onClick={() => getChannelType(0)}>
                        <i className="doc-icon"></i>
                    </a>
                </li>

                <li>
                    <a className={(Array.isArray(filterChannelType) ? filterChannelType : [filterChannelType]).includes(1) ? 'active' : ''} onClick={() => getChannelType(1)}>
                        <i className="email-icon"></i>
                    </a>
                </li>

                <li>
                    <a className={(Array.isArray(filterChannelType) ? filterChannelType : [filterChannelType]).includes(2) ? 'active' : ''} onClick={() => getChannelType(2)}>
                        <i className="cell-phone-icon"></i>
                    </a>
                </li>

                <li>
                    <a className={(Array.isArray(filterChannelType) ? filterChannelType : [filterChannelType]).includes(3) ? 'active' : ''} onClick={() => getChannelType(3)}>
                        <i className="recycle-icon"></i>
                    </a>
                </li>
            </ul>

            <ul className="reporting-sla-radio-box bdr-top">
                {categories?.map((category) => {
                    return (
                        <li key={category.key}>
                            <label htmlFor={category.key}>
                                {category.name}
                            </label>
                            <RadioButton
                                inputId={category.key}
                                name={category.key}
                                value={category.key}
                                onChange={(e) => changeDocType(e)}
                                checked={
                                    filterDocType === category.key
                                }
                            />
                        </li>
                    );
                })}
            </ul>
        </div>
    )
}

export default CommonReportFilter;